/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import { FormattedMessage } from 'react-intl'
import { Alert, AlertProps } from '@mantine/core'

function NoDataAlert (props: AlertProps) {
  const { ...others } = props
  return (
    <Alert {...others}>
      <FormattedMessage
        id="no_data"
        defaultMessage="Aucune donnée"
      />
    </Alert>
  )
}

export default NoDataAlert
